import SearchParamsBase from "../../../Elements/SearchParamsBase";

class PlanningSearchParams extends SearchParamsBase {
    static saveType = 'PlanningSearchParams';
    initialize() {
        this.ServiceId = "";
        this.PricingId =""
    }

    static fieldsInSearchBox = [
        ]

    static iconName = "fa-solid fa-search";
}
 
export default PlanningSearchParams;